import { useQueryClient } from "@tanstack/react-query";
import { invalidateEntity } from "lib/queryKeys";

interface RefreshOptions {
  assetPositionId?: string;
  assetId?: string;
}

export default function useRefreshAssetRegister(options?: RefreshOptions) {
  const queryClient = useQueryClient();

  return async function refreshLists(overrideOptions?: RefreshOptions) {
    const { assetPositionId, assetId } = {
      ...options,
      ...overrideOptions,
    };
    await Promise.all([
      invalidateEntity(queryClient, "asset"),
      invalidateEntity(queryClient, "assetPositionLink", {
        params: { asset_position_id: assetPositionId },
      }),
      invalidateEntity(queryClient, "assetRegister", {
        params: { asset_position_id: assetPositionId },
      }),
      invalidateEntity(queryClient, "asset", {
        params: { asset_id: assetId },
      }),
      invalidateEntity(queryClient, "assetPositionLink", {
        params: { asset_id: assetId },
      }),
    ]);
  };
}
